import React, { useState } from "react";
import "../component/modalAddPartner.css";

import { createPortal } from "react-dom";

const ModalAddPartner = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  partnerObject,
}) => {
  const [partnerData, setPartnerData] = useState(partnerObject);

  const closeModal = () => {
    setPartnerData({
      partner_id: "",
      partner_name: "",
      partner_address: "",
      partner_city: "",
      partner_phone_number: "",
      partner_contact_person_name: "",
      partner_contact_person_phone_number: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-partner-container">
        <div className="modal-partner-content">
          <header className="modal-partner-header">
            <h2 className="modal-partner-header-title">Tambah Partner</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-partner-main">
            <div className="form-group-partner">
              <div className="input-title-label-container">
                <span className="input-title-label">Nama Partner</span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_name ? partnerData.partner_name : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama partner"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Alamat Partner</span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_address
                      ? partnerData.partner_address
                      : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_address: e.target.value,
                    })
                  }
                  placeholder="Masukkan alamat partner"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Kota Alamat Partner</span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_city ? partnerData.partner_city : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_city: e.target.value,
                    })
                  }
                  placeholder="Masukkan kota alamat partner"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Kontak Partner</span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_phone_number
                      ? partnerData.partner_phone_number
                      : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_phone_number: e.target.value,
                    })
                  }
                  placeholder="Masukkan kontak partner"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">
                  Penanggung Jawab Partner
                </span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_contact_person_name
                      ? partnerData.partner_contact_person_name
                      : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_contact_person_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan penanggung jawab partner"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">
                  Kontak Penanggung Jawab
                </span>
              </div>
              <div className="input-partner-field-container">
                <input
                  type="text"
                  value={
                    partnerData.partner_contact_person_phone_number
                      ? partnerData.partner_contact_person_phone_number
                      : ""
                  }
                  onChange={(e) =>
                    setPartnerData({
                      ...partnerData,
                      partner_contact_person_phone_number: e.target.value,
                    })
                  }
                  placeholder="Masukkan kontak penanggung jawab partner"
                />
              </div>
            </div>
          </main>
          <footer className="modal-partner-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = partnerData.partner_id !== "";
                onSubmitData(partnerData, isEditData);
                setPartnerData({
                  partner_id: "",
                  partner_name: "",
                  partner_address: "",
                  partner_city: "",
                  partner_phone_number: "",
                  partner_contact_person_name: "",
                  partner_contact_person_phone_number: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddPartner;
